import { ProdcutRelationshipGroupTypeEnum } from '../../enums/ProductEnums';
import { ProductRelationShipDTO } from '../DTOs/ProductRelationshipDTO';
import { ProductRelationshipGroupDTO } from '../DTOs/ProductRelationshipGroupDTO';
import { IdMapper, ProductBlueprint } from './ProductBlueprint';
import { ProductRelationship } from './ProductRelationship';

export class ProductRelationshipGroup {
  public static getEmptyProductRelationshipGroup() {
    return new ProductRelationshipGroup(undefined, [], [0, 0, 0], ProdcutRelationshipGroupTypeEnum.Preview);
  }

  public static fromDTO(
    productRelationshipGroupDTO: ProductRelationshipGroupDTO,
    availibleBlueprints?: ProductBlueprint[],
  ) {
    const productRelationships: ProductRelationship[] = [];
    for (const productRelationshipDTO of productRelationshipGroupDTO.productRelationships) {
      productRelationships.push(ProductRelationship.fromDTO(productRelationshipDTO, availibleBlueprints));
    }

    return new ProductRelationshipGroup(
      productRelationshipGroupDTO.id ? productRelationshipGroupDTO.id.toString() : undefined,
      productRelationships,
      productRelationshipGroupDTO.position,
      productRelationshipGroupDTO.type,
    );
  }

  private _id: string | undefined;
  private _productRelationships: ProductRelationship[];
  private _position: number[];
  private _type: ProdcutRelationshipGroupTypeEnum;

  public get position() {
    return this._position;
  }

  public get productRelationships() {
    return this._productRelationships;
  }

  public set productRelationships(productRelationships: ProductRelationship[]) {
    this._productRelationships = productRelationships;
  }

  public get type() {
    return this._type;
  }

  public set type(type: ProdcutRelationshipGroupTypeEnum) {
    this._type = type;
  }

  public get id() {
    return this._id;
  }

  constructor(
    id: string | undefined,
    productRelationShips: ProductRelationship[],
    position: number[],
    type: ProdcutRelationshipGroupTypeEnum,
  ) {
    this._id = id;
    this._productRelationships = productRelationShips;
    this._position = position;
    this._type = type;
  }

  public populateProductBlueprintReferences(availibleBlueprints: ProductBlueprint[], idMapper: IdMapper) {
    for (const productRelationship of this._productRelationships) {
      productRelationship.populateProductBlueprintReferences(availibleBlueprints, idMapper);
    }
  }

  public toDTO(): ProductRelationshipGroupDTO {
    const productRelationshipDTOs: ProductRelationShipDTO[] = [];

    for (const productRelationship of this._productRelationships) {
      productRelationshipDTOs.push(productRelationship.toDTO());
    }

    return new ProductRelationshipGroupDTO(
      Number(this._id) || undefined,
      productRelationshipDTOs,
      this._position,
      this._type,
    );
  }

  public dispose() {
    for (const productRelationship of this.productRelationships) {
      productRelationship.dispose();
    }
  }
}
